import test from '../views/Test.vue';
import home from '../views/Home.vue';
import abandoned from '../views/AbandonedCart/Index';
import products from '../views/Products';
import acquisitionForm from '../views/Acquisition/AcquisitionForm.vue';
import planAcquisition from '../views/Acquisition/PlanAcquisition';
import abandonedAcquisition from '../views/AbandonedCart/AbandonedAcquisition';
import renewal from '../views/Renewals/Index';
import renew from '../views/Renewals/Renew';
import wishlist from '../views/Wishlist/Index';
import recentSearch from '../views/RecentSearch/Index';
import abandonedRenew from '../views/AbandonedCart/AbandonedRenew'
import otpVerification from "../components/Auth/OtpVerification";
import emailVerification from "../components/Auth/VerifyEmail";
import forgotPassword from "../components/Auth/ForgotPassword";
import passwordUpdate from "../components/Auth/UpdatePassword";
import usernameVerification from "../components/Auth/UsernameVerification";
import page404 from '../pages/404.vue';
import defaultLayout from '@/layouts/default';

//Profile
import viewProfile from "../views/Profile/View";
import editProfile from "../views/Profile/Edit";
//Wallet
import wallet from "../views/Wallet/MyWallet";
import createWallet from "../views/Wallet/CreateWallet";
//Claim
import claimIndex from '../views/Claims/Index';
import claimView from '../views/Claims/View';
import addClaim from '../views/Claims/AddClaim';
import claim from '../views/Claims/Claim';
//ComplaintFeedback
import ComplaintFeedback from "../views/ComplaintFeedback/Index";
import feedBack from "../views/ComplaintFeedback/Feedback/Index";
import PolicyFeedBack from "../views/ComplaintFeedback/Feedback/Policies";
import ClaimFeedBack from "../views/ComplaintFeedback/Feedback/Claims";
import OverallFeedBack from "../views/ComplaintFeedback/Feedback/Overall";
import complaint from "../views/ComplaintFeedback/Complaint/Index";
import complaintView from "../views/ComplaintFeedback/Complaint/View";
import complaintCreate from "../views/ComplaintFeedback/Complaint/Create";
//Document
import policyDocument from "../views/Documents/PolicyDocument";
import claimDocument from "../views/Documents/ClaimDocument";
//Policy
import policies from "../views/Policy/Index"
import viewPolicy from "../views/Policy/ViewPolicy";
import riskView from "../views/Policy/RiskDetail"
//Notifications
import notifications from '../views/Notifications/Index';
//PolicyServicing
import EndorsementPolicies from "../views/PolicyServicing/Index";
import Endorsements from "../views/PolicyServicing/Listing";
import SubmittedRequest from "../views/PolicyServicing/EndorsementRequests";
import riskAddition from "../views/PolicyServicing/Risk/AddRisk"

import EndorsementDetail from "../views/PolicyServicing/Detail";
import EndorsementRequestForm from "../views/PolicyServicing/Create";
//import WebPageUnderMaintenance from "../views/WebPageUnderMaintenance.vue";
import DeleteRisk from "../views/PolicyServicing/Risk/DeleteRisk";
import ViewRisk from  "../views/PolicyServicing/Risk/ViewRisk";

//Static Pages
import contactUs from "../views/ContactUs";
import privacyPolicy from "../views/PrivacyPolicy";
import terms from "../views/Terms";
import team from "../views/Team";
import faqs from "../views/Faqs";
import promotions from "../views/Promotions";
import aboutUs from "../views/AboutUs";
import RetrievePolicy from "../views/RetrievePolicy";

import legal from "../views/Legal";
import careers from "../views/Careers";
import blog from "../views/Blog";
import siteMap from "../views/SiteMap";
import EndorsementRequests from "../views/PolicyServicing/EndorsementRequests";
export default [
  {
    path: '/otpverification',
    name: 'OtpVerification',
    component: otpVerification
  },
  {
    path: '/verifyemail',
    name: 'EmailVerification',
    component: emailVerification
  },
  {
    path: '/username',
    name: 'UsernameVerification',
    component: usernameVerification
  },
  {
    path: '/forgot_password',
    name: 'ForgotPassword',
    component: forgotPassword
  },
  {
    path: '/password/update',
    name: 'UpdatePassword',
    component: passwordUpdate
  },
  {
    path: "/claim/",
    component: defaultLayout,
    children: [
      //AddClaim should be change below
      { name: 'AddClaim', path: 'add', props: true, component: addClaim, meta: { requiresAuth: true, requiresOTP: true, verifyUsername: true, verifyEmail: true }},
      { name: 'ClaimsView', path: ':id', props: true, component: claimView, meta: { requiresAuth: true, requiresOTP: true, verifyUsername: true, verifyEmail: true }},
      // { name: 'AddClaim', path: 'add', props: true, component: claim, meta: { requiresAuth: true, requiresOTP: true, verifyUsername: true, verifyEmail: true }},
    ]
  },
  {
    path: "/profile/",
    component: defaultLayout,
    children: [
      { name: 'ViewProfile', path: 'view', props: true, component: viewProfile, meta: { requiresAuth: true, requiresOTP: true, verifyUsername: true, verifyEmail: true }},
      { name: 'EditProfile', path: 'edit', props: true, component: editProfile, meta: { requiresAuth: true, requiresOTP: true, verifyUsername: true, verifyEmail: true }},
    ]
  },
  {
    path: "/complaint/",
    component: defaultLayout,
    children: [
      { name: 'Complaint', path: '', component: complaint, meta: { requiresAuth: true, requiresOTP: true, verifyUsername: true, verifyEmail: true }},
      { name: 'ComplaintCreate', path: 'create', props: true, component: complaintCreate, meta: { requiresAuth: true, requiresOTP: true, verifyUsername: true, verifyEmail: true }},
      { name: 'ComplaintView', path: ':id', props: true, component: complaintView, meta: { requiresAuth: true, requiresOTP: true, verifyUsername: true, verifyEmail: true }}
    ]
  },
  {
    path: "/policy/",
    component: defaultLayout,
    children: [
      { name: 'PolicyView', path: ':source/:id', props: true, component: viewPolicy, meta: { requiresAuth: true, requiresOTP: true, verifyUsername: true, verifyEmail: true }},
      { name: 'RiskView', path: 'risk/detail/:id/:policyId', component: riskView, meta: { requiresAuth: true, requiresOTP: true, verifyUsername: true, verifyEmail: true }},
    ]
  },
  {
    path: "/feedback/",
    component: defaultLayout,
    children: [
      { name: 'PoliciesFeedback', path: 'policies', component: PolicyFeedBack, meta: { requiresAuth: true, requiresOTP: true, verifyUsername: true, verifyEmail: true }},
      { name: 'ClaimsFeedback', path: 'claims', component: ClaimFeedBack, meta: { requiresAuth: true, requiresOTP: true, verifyUsername: true, verifyEmail: true }},
      { name: 'Overall', path: 'overall', component: OverallFeedBack, meta: { requiresAuth: true, requiresOTP: true, verifyUsername: true, verifyEmail: true }}
    ]
  },
  {
    path: "/policyservicing/",
    component: defaultLayout,
    children: [
      { name: 'PolicyServicing', path: '', component: EndorsementPolicies, meta: { requiresAuth: true, requiresOTP: true, verifyUsername: true, verifyEmail: true }},
      { name: 'Endorsements', path: ':id', component: Endorsements, meta: { requiresAuth: true, requiresOTP: true, verifyUsername: true, verifyEmail: true }},
      { name: 'SubmittedRequest', path: 'submitted_requests/:id', component: SubmittedRequest, meta: { requiresAuth: true, requiresOTP: true, verifyUsername: true, verifyEmail: true }},
      { name: 'EndorsementDetail', path: 'detail/:id', component: EndorsementDetail, meta: { requiresAuth: true, requiresOTP: true, verifyUsername: true, verifyEmail: true }},
      { name: 'EndorsementRequestForm', path: 'create/:id/:quotation_id/:type', component: EndorsementRequestForm, meta: { requiresAuth: true, requiresOTP: true, verifyUsername: true, verifyEmail: true }},
      { name: 'DeleteRisk', path: 'risk_deletion/:id/:quotation_id/:type', component: DeleteRisk, meta: { requiresAuth: true, requiresOTP: true, verifyUsername: true, verifyEmail: true }},
      { name: 'ViewRisk', path: 'risk_view/:id/:quotation_id/:type', component: ViewRisk, meta: { requiresAuth: true, requiresOTP: true, verifyUsername: true, verifyEmail: true }},

      { name: 'EndorsementRiskAddition', path: 'risk_addition/:id/:quotation_id', component: riskAddition, meta: { requiresAuth: true, requiresOTP: true, verifyUsername: true, verifyEmail: true }},
    ]
  },
  {
    path: "/",
    component: defaultLayout,
    children: [
     // { name: 'WebPageUnderMaintenance', path: 'UnderMaintenance', component: WebPageUnderMaintenance },
     { name: 'ViewWallet', path: 'view_wallet', component: wallet},
     { name: 'CreateWallet', path: 'create_wallet', component: createWallet},
      { name: 'test', path: 'test0011', component: test },
      { name: 'Home', path: '', component: home, meta: { requiresAuth: false, requiresOTP: false, verifyUsername: false, verifyEmail: false }},
      { name: 'ContactUs', path: 'contactus', component: contactUs, meta: { requiresAuth: false, requiresOTP: false, verifyUsername: false, verifyEmail: false }},
      { name: 'AboutUs', path: 'aboutus', component: aboutUs, meta: { requiresAuth: false, requiresOTP: false, verifyUsername: false, verifyEmail: false }},
      { name: 'RetrievePolicy', path: 'retrieve_policy', component: RetrievePolicy, meta: { requiresAuth: false, requiresOTP: false, verifyUsername: false, verifyEmail: false }},

      { name: 'PrivacyPolicy', path: 'privacypolicy', component: privacyPolicy, meta: { requiresAuth: false, requiresOTP: false, verifyUsername: false, verifyEmail: false }},
      { name: 'Terms', path: 'termsofuse', component: terms, meta: { requiresAuth: false, requiresOTP: false, verifyUsername: false, verifyEmail: false }},
      { name: 'Legal', path: 'legal', component: legal, meta: { requiresAuth: false, requiresOTP: false, verifyUsername: false, verifyEmail: false }},
      { name: 'FAQS', path: 'faqs', component: faqs, meta: { requiresAuth: false, requiresOTP: false, verifyUsername: false, verifyEmail: false }},
      { name: 'Careers', path: 'careers', component: careers, meta: { requiresAuth: false, requiresOTP: false, verifyUsername: false, verifyEmail: false }},
      { name: 'Blog', path: 'blog', component: blog, meta: { requiresAuth: false, requiresOTP: false, verifyUsername: false, verifyEmail: false }},
      { name: 'SiteMap', path: 'sitemap', component: siteMap, meta: { requiresAuth: false, requiresOTP: false, verifyUsername: false, verifyEmail: false }},
      { name: 'Team', path: 'team', component: team, meta: { requiresAuth: false, requiresOTP: false, verifyUsername: false, verifyEmail: false }},
      { name: 'Promotions', path: 'promotions', component: promotions, meta: { requiresAuth: false, requiresOTP: false, verifyUsername: false, verifyEmail: false }},
      { name: 'Acquisition', path: '/acquisition/:classId', component: acquisitionForm, props: true, meta: { requiresAuth: false, requiresOTP: true, verifyUsername: true, verifyEmail: true }},
      { name: 'AbandonedAcquisition', path: '/abandoned_acquisition/:quotationId/:subClassId/:riskId/:provideInformationThrough/:planId/:productPrice/:currency', component: abandonedAcquisition, props: true, meta: { requiresAuth: true, requiresOTP: true, verifyUsername: true, verifyEmail: true }},
      { name: 'PlanAcquisition', path: '/plan_acquisition/:redirectFrom/:planId', component: planAcquisition, props: true, meta: { requiresAuth: false, requiresOTP: true, verifyUsername: true, verifyEmail: true }},
      { name: 'Renewal', path: '/renewals', component: renewal, props: true, meta: { requiresAuth: true, requiresOTP: true, verifyUsername: true, verifyEmail: true }},
      { name: 'Renew', path: '/renew/:quotationId/:subClassId/:riskId/:provideInformationThrough', component: renew, props: true, meta: { requiresAuth: true, requiresOTP: true, verifyUsername: true, verifyEmail: true }},
      { name: 'AbandonedRenew', path: '/abandoned_renew/:parentId/:quotationId/:subClassId', component: abandonedRenew, props: true, meta: { requiresAuth: true, requiresOTP: true, verifyUsername: true, verifyEmail: true }},
      { name: 'Claims', path: 'claims', component: claimIndex, meta: { requiresAuth: true, requiresOTP: true, verifyUsername: true, verifyEmail: true }},
      { name: 'FeedBack', path: 'feedback', component: feedBack, meta: { requiresAuth: true, requiresOTP: true, verifyUsername: true }},
      { name: 'ComplaintFeedback', path: 'complaint_feedback', component: ComplaintFeedback, meta: { requiresAuth: true, requiresOTP: true, verifyUsername: true, verifyEmail: true }},
      { name: 'PolicyDocument', path: 'policy_documents', component: policyDocument, meta: { requiresAuth: true, requiresOTP: true, verifyUsername: true, verifyEmail: true }},
      { name: 'ClaimDocument', path: 'claim_documents', component: claimDocument, meta: { requiresAuth: true, requiresOTP: true, verifyUsername: true, verifyEmail: true }},
      { name: 'Policies', path: 'policies', component: policies, meta: { requiresAuth: true, requiresOTP: true, verifyUsername: true, verifyEmail: true }},
      { name: 'Notifications', path: 'notifications', component: notifications, meta: { requiresAuth: true, requiresOTP: true, verifyUsername: true, verifyEmail: true }},
      { name: 'AbandonedCart', path: '/abandoned', component: abandoned, props: true, meta: { requiresAuth: true, requiresOTP: true, verifyUsername: true, verifyEmail: true }},
      { name: 'Products', path: '/products', component: products, meta: { requiresAuth: false, requiresOTP: true, verifyUsername: true, verifyEmail: true }},
      { name: 'Wishlist', path: '/wishlist', component: wishlist, meta: { requiresAuth: true, requiresOTP: true, verifyUsername: true, verifyEmail: true }},
      { name: 'RecentSearch', path: '/recent_search', component: recentSearch, meta: { requiresAuth: true, requiresOTP: true, verifyUsername: true, verifyEmail: true }},
    ]
  },
  {
    // Always leave this as last one
    path: '*',
    component: page404
  }
]



// WEBPACK FOOTER //
// ./src/router/routes.js